import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: JSON.parse(localStorage.getItem('favoriteItems')) || [],
};

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    setFavorites: (state, action) => {
      state.items = action.payload;
      localStorage.setItem('favoriteItems', JSON.stringify(state.items));
    },
    toggleFavorite: (state, action) => {
      const product = action.payload;
      // Ensure we compare with product.id
      const index = state.items.findIndex((item) => String(item.id) === String(product.id));
      if (index !== -1) {
        state.items.splice(index, 1);
      } else {
        state.items.push(product);
      }
      localStorage.setItem('favoriteItems', JSON.stringify(state.items));
    },
  },
});

export const { toggleFavorite, setFavorites } = favoritesSlice.actions;
export default favoritesSlice.reducer;
